import React, { useState } from 'react';
import './landiningfotter.css';
import iiaLogo from '../../img/aaaservices/LogoIIAHead.png';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      alert(`Subscribed with: ${email}`);
      setEmail('');
    }
  };

  const programCategories = [
    { label: 'Tool Design & Manufacturing', href: '/' },
    { label: 'Robotics & Simulation', href: '/' },
    { label: 'Digital Manufacturing', href: '/' },
    { label: 'Industrial Automation', href: '/' },
    { label: 'Mechanical Design & CAD', href: '/' },
    { label: 'IT & Emerging Technologies', href: '/' }
  ];

  // Address data
  const addresses = [
    {
      city: 'Hyderabad',
      branches: [
        {
          name: 'Manjeera Trinity Corporate',
          address: 'Manjeera Trinity Corporate, 6th Floor, Tower B, Kukatpally, Hyderabad, Telangana 500072'
        },
        
      ]
    },
    {
      city: 'Jaipur',
      branches: [
        {
          name: 'Nr 205, Second Floor Regus Jaipur ',
          address: 'Plot no: B/C 59 Central Spine,OB Infra Tower, Jaipur,302025, Rajasthan'
        },

      ]
    }
  ];

  return (
    <footer className="iia-footer">
      <div className="footer-container">
        {/* ===== Top Section ===== */}
        <div className="footer-top">
          {/* Logo & Description */}
          <div className="footer-brand">
            <div className="footer-logo-wrapper">
              <img src={iiaLogo} alt="IIA Logo" className="footer-logo" />
              <div className="footer-logo-text">
                <span className="footer-logo-title">
                  International Institute
                  <br />
                  of <span className="footer-logo-highlight">Automate</span>
                </span>
                <span className="footer-logo-sub">Building Industry-Ready Engineers</span>
              </div>
            </div>
            <p className="footer-description">
              International Institute of Automate (IIA) is an industry-integrated engineering 
              training institute committed to developing industry-ready engineers through 
              practical learning, industry exposure and expert mentorship.
            </p>
          </div>

          {/* Program Categories */}
          <div className="footer-links">
            <h3 className="footer-heading">PROGRAM CATEGORIES</h3>
            <ul className="footer-link-list">
              {programCategories.map((category, index) => (
                <li key={index}>
                  <a href={category.href} className="footer-link">
                    {category.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer-links">
            <h3 className="footer-heading">CONTACT US</h3>
            <div className="footer-contact-info">
              <div className="footer-contact-item">
                <span className="footer-contact-icon">📞</span>
                <span>+91 8096120173 </span>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon">✉️</span>
                <span>info@iiautomate.com</span>
              </div>
              <div className="footer-contact-item">
                {/* <span className="footer-contact-icon">▶️</span>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="footer-youtube-link">
                  IIA YouTube Channel
                </a> */}
              </div>
            </div>
          </div>

          {/* Address Section */}
          <div className="footer-address">
            <h3 className="footer-heading">OUR CENTERS</h3>
            <div className="address-container">
              {addresses.map((cityData, idx) => (
                <div key={idx} className="address-city-group">
                  <h4 className="address-city">{cityData.city}</h4>
                  {cityData.branches.map((branch, bidx) => (
                    <div key={bidx} className="address-item">
                      <div className="address-icon">📍</div>
                      <div className="address-details">
                        <div className="address-name">{branch.name}</div>
                        <div className="address-text">{branch.address}</div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ===== Bottom Section ===== */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © 2024 International Institute of Automate (IIA). All Rights Reserved.
            </p>
            <p className="footer-powered">
              Powered by Envision Integrated Services
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;